/**
 * <Picture> - WebP-optimized image with fallback.
 * For Unsplash & Emergent CDN URLs, generates WebP variants via query params.
 * For uploaded images (from our backend), passes through as-is (browser handles).
 */
export default function Picture({
  src,
  alt = "",
  className = "",
  loading = "lazy",
  width,
  height,
  fetchpriority,
  ...rest
}) {
  if (!src) return null;

  const isUnsplash = src.includes("images.unsplash.com");
  const isEmergent = src.includes("static.prod-images.emergentagent.com");

  const buildVariant = (format, w) => {
    if (isUnsplash) {
      const u = new URL(src);
      u.searchParams.set("fm", format);
      if (w) u.searchParams.set("w", String(w));
      if (!u.searchParams.get("q")) u.searchParams.set("q", "80");
      return u.toString();
    }
    if (isEmergent) {
      return src;
    }
    return src;
  };

  const webp = buildVariant("webp", width);
  const jpg = buildVariant("jpg", width);

  // fetchPriority attribute (React 18+) for browsers supporting it
  const imgProps = {
    src: isUnsplash ? jpg : src,
    alt,
    loading,
    decoding: "async",
    width,
    height,
    className,
    ...(fetchpriority ? { fetchPriority: fetchpriority } : {}),
    ...rest,
  };

  return (
    <picture>
      {isUnsplash && <source type="image/webp" srcSet={webp} />}
      <img {...imgProps} />
    </picture>
  );
}
